import React from 'react'

export const TimeConverter = (hour=0, minute=0) => {
return hour?.toString().padStart(2, '0')+":"+minute?.toString().padStart(2, '0')
}
